import type { NavSectionProps } from 'src/components/nav-section';

import { paths } from 'src/routes/paths';

import { CONFIG } from 'src/global-config';

import { Label } from 'src/components/label';
import { SvgColor } from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`${CONFIG.assetsDir}/assets/icons/navbar/${name}.svg`} />
);

const ICONS = {
  job: icon('ic-job'),
  blog: icon('ic-blog'),
  chat: icon('ic-chat'),
  mail: icon('ic-mail'),
  user: icon('ic-user'),
  file: icon('ic-file'),
  lock: icon('ic-lock'),
  tour: icon('ic-tour'),
  order: icon('ic-order'),
  label: icon('ic-label'),
  blank: icon('ic-blank'),
  kanban: icon('ic-kanban'),
  folder: icon('ic-folder'),
  course: icon('ic-course'),
  banking: icon('ic-banking'),
  booking: icon('ic-booking'),
  invoice: icon('ic-invoice'),
  product: icon('ic-product'),
  calendar: icon('ic-calendar'),
  disabled: icon('ic-disabled'),
  external: icon('ic-external'),
  menuItem: icon('ic-menu-item'),
  ecommerce: icon('ic-ecommerce'),
  analytics: icon('ic-analytics'),
  dashboard: icon('ic-dashboard'),
  parameter: icon('ic-parameter'),
};

// ----------------------------------------------------------------------

export const navData: NavSectionProps['data'] = [
  /**
   * Overview
   */
  {
    subheader: 'Anwendungen',
    items: [
      {
        title: 'Etikettenentfernung',
        path: paths.apps.etikettenentfernung.root,
        icon: ICONS.parameter,
        info: <Label>v{CONFIG.appVersion}</Label>,
        children: [
          { title: 'Live Ansicht', path: paths.apps.etikettenentfernung.live },
          { title: 'Tabellen Ansicht', path: paths.apps.etikettenentfernung.list },
          { title: 'Reinigungsbilder', path: paths.apps.etikettenentfernung.cleaningImages },
        ]
      },
      {
        title: 'Rebo Pipeline',
        path: paths.apps.reboPipeline.root,
        icon: ICONS.parameter,
        children: [
          { title: 'Live', path: paths.apps.reboPipeline.live },
          { title: 'Tabelle', path: paths.apps.reboPipeline.list },
        ],
      },
      {
        title: 'Schwerte Uploads',
        path: paths.apps.webUploads.root,
        icon: ICONS.file,
      },
    ],
  },
];
